<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    label="nome"
    track-by="id_metodo_pagamento_site"
    :disabled="isDisabled"
    placeholder=""
    :loading="isLoading"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'localidadeSelected',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isFilterIDs',
    'filterIds'
  ],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_meio_pagamento', null);
        return;
      }
      this.$emit('selectChange', 'id_meio_pagamento', e.id);
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => option.id === value);
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    getFilterString(localidadeId) {
      if (this.isFilterIDs == true && this.filterIds && this.filterIds.length) {
        let filterstring = ` metodo_pagamento_site.ativo IS true AND (`;

        this.filterIds.forEach((fi, i) => {
          if (i != 0) {
            filterstring += ' or ';
          }

          filterstring += ` metodo_pagamento_site.id = ${fi} `;
        });

        filterstring += ' ) ';

        return filterstring;
      }
      return ` metodo_pagamento_site.ativo IS true AND ${localidadeId} = any(select (json_array_elements(localidade_web.id_localidades)::text)::integer)`;
    },
    setOptions(localidadeId) {
      this.isLoading = true;
      let params = {
        columns: 'id as id_metodo_pagamento_site',
        related: 'tipo_metodo_pagamento:nome AS nome,id AS id',
        filter: this.getFilterString(localidadeId),
        order: 'id_metodo_pagamento_site'
      };
      this.$atenaList
        .getMetodosPagamento(params)
        .then((res) => {
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },

  watch: {
    localidadeSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
        this.onChange();
      }
    }
  },

  created() {
    if (this.localidadeSelected) this.setOptions(this.localidadeSelected);
  }
};
</script>

<style lang="scss" scoped></style>
